import { PageContext } from 'context/PageContext';
import { useContext, useEffect } from 'react';
import { useAppSelector } from 'store/hooks';
import { pushToDataLayer, trackAddPaymentInfo, trackAddShippingInfo } from '../services/TrackingService';

export const useTracking = () => {
	const { metaArea } = useContext(PageContext);
	const form = useAppSelector((state) => state.calculatorForm);

	useEffect(() => {
		if (!form['SELECTED_PACKAGE_PAYMENT_FREQUENCY']) {
			return;
		}

		trackAddPaymentInfo(metaArea);
		// the next step shows the personal info step, so we can track add shipping info here as well
		trackAddShippingInfo(metaArea);
		pushToDataLayer();
	}, [form['SELECTED_PACKAGE_PAYMENT_FREQUENCY']]);
};
